import { useMemo,useRef } from 'react';

import { getDataFilter, getFilterValuesForDL } from '@ge/shared/util/data-filter';
import { dedupArray, searchStr } from '@ge/shared/util/general';

/**
 * Get filtered table data.
 *
 * @param data
 * @param filters
 * @param search
 * @returns {data: Array, filterValues: Object}
 */

export const useDlTableFilter = ({ data, filters, search, isTaskTable }) => {
  const { key, value } = search ?? {};
  const filterDict = Object.entries(filters || {});
  const primarySelectionFieldRef = useRef(null);

  const { data: filteredData } = useMemo(() => getDataFilter({ data, filters, isTaskTable, isDistributionList: true }), [
    JSON.stringify(data),
    filters,
    isTaskTable,
  ]);


  const areAllFiltersCleared = filterDict.every(([_, filterOptions]) => {
    return !filterOptions.value || (Array.isArray(filterOptions.value) && filterOptions.value.length === 0);
  });

  if (areAllFiltersCleared) {
    primarySelectionFieldRef.current = null;
  }

  if (!primarySelectionFieldRef.current) {
    filterDict.forEach(([field, filterOptions]) => {
      if (filterOptions.value) {
        primarySelectionFieldRef.current = field;
      }
    });
  }

  const filterValues = useMemo(() => getFilterValuesForDL(data, filters, primarySelectionFieldRef.current), [JSON.stringify(data), filters])

  const searchValues = useMemo(
    () =>
      dedupArray(
        value
          ? data
              ?.map((item) => {
                const itemValue = item[key];

                // TODO: review but right now expecting if cell value is complex that it has a description prop
                // otherwise try to match cell value directly assuming it's text
                return itemValue?.description ?? itemValue?.name ?? itemValue;
              })
              .filter((itemValue) => searchStr(itemValue, value))
          : data,
      ),
    [data, key, value],
  );

  return useMemo(
    () => ({
      data: filteredData,
      filterValues: !(key && value)
        ? filterValues
        : {
            ...filterValues,
            [key]: searchValues,
          },
    }),
    [filterValues, filteredData, key, searchValues, value],
  );
};
